// AUTOGENERATED: DO NOT EDIT

import { Assets } from "pixi.js";
import cool from "../../assets/img/cool/cool.png";
import { loadcool } from "./cool";

export const loadSpritesheets = async () => {
  return Assets.load([cool]).then(() => Promise.all([loadcool()]));
};
